<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st10"
      :custom="{storage: true}"
      export
      :refresh="{query: RefreshList}"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('LoanList_search_button')"
          @click="funcFilter"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('LoanList_batchHandle_button')"
          type="primary"
          @click="batchMoney"
        >
          批量处理
        </el-button>
        <el-button
          v-if="getLimit('LoanList_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :checkbox-config="{checkMethod}"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      class="mytable-footer"
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column
        type="checkbox"
        width="60"
        fixed="left"
      />
      <vxe-table-column>
        <vxe-table-column
          field="status"
          title="申请状态"
          :formatter="formatterStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.status"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bizNo"
          title="支付批次号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bizNo"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="applyer"
          title="申请人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.applyer"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="applyerPhone"
          title="手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.applyerPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankName"
          title="银行名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankAcountName"
          title="姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankAcountName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankNumber"
          title="卡号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankNumber"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="money"
          title="金额"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.moneyStart"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col
              :span="11"
              :offset="2"
            >
              <el-input
                v-model="listQuery.moneyEnd"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="bankMobile"
          title="预留手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.bankMobile"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="applyDate"
          title="申请时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.applyDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'applyDate')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="transferTime"
          title="转账时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.transferTimeRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'transferTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="remark"
          title="备注"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.remark"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="payStatus"
          title="转账渠道"
          :formatter="formatterPayStatus"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.payStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in payStatusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="errorMsg"
          title="转账反馈"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.errorMsg"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { transferApply, transferConfirm } from "@/api/invoice";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      exportObj:{
        exportUrl:"/ntocc-basic-api/transferApply/exportTransferApply",//导出接口
        name:'提现放款'
      },
      listQuery: {
        transferTimeRange: [],
        applyDateRange: [],
        status: '',
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // Pagingconf: [],
      sumObject: {},
      options: [
        {
          value: 0,
          label: "提现申请"
        },
        {
          value: 1,
          label: "提交成功"
        },
        {
          value: 2,
          label: "转账成功"
        },
        {
          value: 3,
          label: "转账失败"
        },
        {
          value: 4,
          label: "处理中"
        },
        {
          value: 5,
          label: "驳回"
        }
      ],
      payStatusOptions: [
        {
          value: 0,
          label: "线下"
        },
        {
          value: 1,
          label: "网商"
        },
        // {
        //   value: 2,
        //   label: "宝付"
        // }
      ]
    };
  },
  watch:{
    $route(to,from) {
      const v = to.query.todo;
      if(v){
        this.listQuery.status = 0;
      }else{
        this.listQuery.status = '';
      }
      this.findList();
    }
  },
  created() {
    const v = this.$route.query.todo;
    if(v){
      this.listQuery.status = 0;
    }
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        transferApply(this.listQuery).then(response => {
          this.tableData = response.data.records;
          // response.data.total>10000? this.Pagingconf = [20, 30, 50, 100,10000]:this.Pagingconf = [20, 30, 50, 100, response.data.total || 1];
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 选框
    checkMethod({ row }) {
      return row.status === 0 || row.status === 3;
    },
    // 批量打款
    batchMoney() {
      const checkedRowArray = this.$refs.xTable.getSelectRecords();
      if (!checkedRowArray || checkedRowArray.length === 0) {
        this.$message({ message: "请选择需要提现的项", type: "warning" });
        return false;
      }
      const transferApplyCodes = checkedRowArray
        .map(item => item.code)
        .join(",");
      this.$confirm("确认批量打款吗？").then(_ => {
        this.$refs.xTable.clearCheckboxRow()
        transferConfirm({ transferApplyCodes }).then(response => {
          this.$message({ message: response.msg, type: "success" });
          this.findList();
        });
      });
    },
    // 状态
    formatterStatus({ cellValue }) {
      const item = this.options.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    // 转账渠道
    formatterPayStatus({ cellValue }) {
      const item = this.payStatusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return "合计";
            }
            if (column.property === "money") {
              return this.$XEUtils.sum(data, column.property);
            }
            return "-";
          })
        ];
      }
  }
};
</script>
